import { Code } from '@tiptap/extension-code';

// Tiptap's code mark excludes every other mark, so a DOCX import had to drop the italic,
// bold or colour on a monospace run to show it as code. Letting it combine keeps both.
export const InlineCode = Code.extend({
  excludes: 'code',
});
